import {
    TagCloudTargetingsState,
    TagValue,
    TargetingValueItem
} from '../typings/tagCloudTargeting';

export const OPEN_TAG_CLOUD_TARGETING = 'OPEN_TAG_CLOUD_TARGETING';
export type OPEN_TAG_CLOUD_TARGETING = typeof OPEN_TAG_CLOUD_TARGETING;

export interface TagCloudTargetingOpenAction {
    type: OPEN_TAG_CLOUD_TARGETING;
    editorId: string;
}

export const openTagCloudTargeting = (
    editorId: string
): TagCloudTargetingOpenAction => {
    return {
        type: OPEN_TAG_CLOUD_TARGETING,
        editorId
    };
};

export const CLOSE_TAG_CLOUD_TARGETING = 'CLOSE_TAG_CLOUD_TARGETING';
export type CLOSE_TAG_CLOUD_TARGETING = typeof CLOSE_TAG_CLOUD_TARGETING;

export interface TagCloudTargetingCloseAction {
    type: CLOSE_TAG_CLOUD_TARGETING;
    editorId: string;
}

export const closeTagCloudTargeting = (
    editorId: string
): TagCloudTargetingCloseAction => {
    return {
        type: CLOSE_TAG_CLOUD_TARGETING,
        editorId
    };
};

export const SAVE_TAG_CLOUD_TARGETING = 'SAVE_TAG_CLOUD_TARGETING';
export type SAVE_TAG_CLOUD_TARGETING = typeof SAVE_TAG_CLOUD_TARGETING;

export interface TagCloudTargetingSaveAction {
    type: SAVE_TAG_CLOUD_TARGETING;
    editorId: string;
    onTargetingSave?: (value: TagValue[]) => TagValue[];
}

export const saveTagCloudTargeting = (
    editorId: string,
    onTargetingSave?: (value: TagValue[]) => TagValue[]
): TagCloudTargetingSaveAction => {
    return {
        type: SAVE_TAG_CLOUD_TARGETING,
        editorId,
        onTargetingSave
    };
};

export const CHANGE_TAG_CLOUD_TARGETING_VALUE =
    'CHANGE_TAG_CLOUD_TARGETING_VALUE';
export type CHANGE_TAG_CLOUD_TARGETING_VALUE = typeof CHANGE_TAG_CLOUD_TARGETING_VALUE;

export interface TagCloudTargetingValueChangeAction {
    type: CHANGE_TAG_CLOUD_TARGETING_VALUE;
    editorId: string;
    value: TargetingValueItem;
}

export const changeTagCloudTargetingValue = (
    editorId: string,
    value: TargetingValueItem
): TagCloudTargetingValueChangeAction => {
    return {
        type: CHANGE_TAG_CLOUD_TARGETING_VALUE,
        editorId,
        value
    };
};

export const UPDATE_TAG_CLOUD_TARGETINGS = 'UPDATE_TAG_CLOUD_TARGETINGS';
export type UPDATE_TAG_CLOUD_TARGETINGS = typeof UPDATE_TAG_CLOUD_TARGETINGS;

export interface TagCloudTargetingsUpdateAction {
    type: UPDATE_TAG_CLOUD_TARGETINGS;
    editors: TagCloudTargetingsState;
}

export const updateTagCloudTargetings = (
    editors: TagCloudTargetingsState
): TagCloudTargetingsUpdateAction => {
    return {
        type: UPDATE_TAG_CLOUD_TARGETINGS,
        editors
    };
};

export type TagCloudTargetingEditorAction =
    | TagCloudTargetingOpenAction
    | TagCloudTargetingCloseAction
    | TagCloudTargetingSaveAction
    | TagCloudTargetingValueChangeAction
    | TagCloudTargetingsUpdateAction;
